export default __webpack_public_path__ + "static/media/rk2.e909dc4a.png";